export default __webpack_public_path__ + "static/media/page-v5-2.76522041.png";